import { render } from "./RadarClaire.vue?vue&type=template&id=128e9eca"
import script from "./RadarClaire.vue?vue&type=script&lang=js"
export * from "./RadarClaire.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__